import React, { useContext } from "react";
import { PendoService, CommonService } from "@services";
import { SearchContext } from "../../../contexts/Search";
const DynamicCell = ({
  rowValue,
  iconPath,
  displayPrefix,
  altText,
  iconDisplayPosition,
}) => {
  
  const {productId, productName, indicationName } = useContext(SearchContext);

  const handleClick = (value) => {
    PendoService.getInstance().trackEvent('Form Link Icon', value, displayPrefix, productId, productName, indicationName);
  };
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {displayPrefix && (!iconDisplayPosition || iconDisplayPosition === 1) && <span part="cfDisplayPrefix" className="norstella-cf-displayPrefix">{displayPrefix}</span>}
      {iconPath ? (
        <img
          part="cfDisplayRowCellIcon"
          className={`norstella-cf-DynamicColCellIcon ${iconDisplayPosition === 2 ? "norstella-cf-DynamicColCellIconBefore" : ""}`}
          src={iconPath}
          alt={altText ?? "icon"}
          onClick={() => {
            handleClick(rowValue);
            window.open(rowValue, "_blank");
          }}
        />

      ) : CommonService.isUrl(rowValue) ? (
        <a
          className="norstella-cf-href"
          part="cfhref"
          target="_blank"
          rel="noreferrer"
          href={rowValue}
          onClick={() => handleClick(rowValue)}
        >
          {rowValue}
        </a>
      ) : (
        rowValue
      )}
      {displayPrefix && iconDisplayPosition === 2 && <span part="cfDisplayPrefix" className="norstella-cf-displayPrefix">{displayPrefix}</span>}
    </div>
  );
};

export default DynamicCell;